var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.category !== null && _vm.tid ? "nuxt-link" : "div",
    {
      tag: "component",
      staticClass: "range",
      attrs: {
        to: `/search?sort_by=created${_vm.jurisdictionQuery}${_vm.subjectQuery}`,
      },
    },
    [
      _c("div", { staticClass: "range__bar" }, [
        _c("span", {
          class: _vm.colorBar,
          style: "width: " + (_vm.width + 2) + "%",
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "range__text" }, [_vm._v(_vm._s(_vm.text))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }